import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      serialModal: {
        show: false,
        loading: false,
      },
      serial: {
        selected: [],
        product: null,
        skuId: null,
        whId: null,
        sort: {
          key: 'date_in',
          value: 'asc',
        },
        isCustomPrice: false,
      },
    }
  },

  computed: {
    ...mapState('serial', {
      serialList: 'serialList',
    }),
  },

  methods: {
    ...mapActions('serial', {
      getSerialList: 'getSerialList',
    }),
    async handleSortSerialChange ({ key, value }) {
      this.serialModal.loading = true
      this.serial.sort.key = key
      this.serial.sort.value = value
      await this.fetchSerialData()
      this.serialModal.loading = false
    },
    async fetchSerialData () {
      await this.getSerialList({
        page: 1,
        limit: 100000,
        'filter[sku_id]': this.serial.skuId,
        'filter[wh_id]': this.serial.whId,
        'filter[unit_balance_empty]': 'false',
        'sort[key]': this.serial.sort.key,
        'sort[value]': this.serial.sort.value,
      })
      this.showFinish(this.$Progress)
    },
    mapSerials (selectedItems) {
      return selectedItems.map((serial) => {
        return {
          serId: serial.serId,
          serCode: serial.serCode,
          serialNumber: serial.serialNumber,
          binId: serial.binId,
          binName: serial.binName,
          unit: 1,
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/posSelectSerial.js